import React from 'react';

import ErrorIcon from '../../assets/icons/error.svg';
import Spinner from '../atoms/Spinner';

interface TraniningWrapperProps {
	children: React.ReactNode;
	isLoading: boolean;
	isError: boolean;
}

const TraniningWrapper: React.FC<TraniningWrapperProps> = (props) => {
	return (
		<div className="h-[85vh] w-[92vw]">
			{props.isLoading ? (
				<div className="my-4 flex h-full w-full items-center rounded-md bg-white">
					<Spinner size={40} />
				</div>
			) : props.isError ? (
				<div className="h-full w-full px-[1%]">
					<div className="flex h-full w-full flex-col items-center justify-center rounded-md bg-white">
						<img src={ErrorIcon} alt="Ícone de erro" className="w-24" />
						<div className="flex flex-col items-center text-center">
							Não foi possível carregar os dados
							<span className="font-semibold text-blue-800">
								tente novamente mais tarde!
							</span>
						</div>
					</div>
				</div>
			) : (
				<div className="mt-4 flex h-full w-full flex-col gap-4">
					{props.children}
				</div>
			)}
		</div>
	);
};

export default TraniningWrapper;
